<template>
    <div class="single-text-wrapper">
        <div class="form-sel-item">
            <div class="input-opt"><input :placeholder="title" :value="titleValue" type="text" @change="titleChange" /></div>
        </div>
        <div class="form-sel-item">
            <div class="input-opt"><input :placeholder="inputTips" type="text" :value="inputValue" @change="tipChange" /></div>
        </div>
        <div class="form-sel-item sel-item-add">
            <div class="sel-radio">
                <div :class="{ on: isSelected }" @click="radioSelect"></div>
                {{ isNeedRadio }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SingleText",
    props: ["data"],
    computed: {
        title() {
            return this.$t("zhiji.form.singleText.input.title");
        },
        inputTips() {
            return this.$t("zhiji.form.singleText.input.tip");
        },
        isNeedRadio() {
            return this.$t("zhiji.form.isNeedRadio");
        },
        titleValue() {
            return this.data.title || "";
        },
        inputValue() {
            return this.data.tip || "";
        },
        isSelected() {
            return this.data.isNeed || false;
        }
    },
    methods: {
        radioSelect() {
            this.commitStore({
                isNeed: !this.isSelected
            });
        },
        commitStore(widget) {
            widget.uId = this.data.uId;
            this.$store.commit("zhiji/editFormContents", {
                type: "updateFormContent",
                widget: widget
            });
        },
        titleChange(event) {
            this.commitStore({
                title: event.target.value
            });
        },
        tipChange(event) {
            this.commitStore({
                tip: event.target.value
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.single-text-wrapper {
    font-size: 12px;
    padding: 8px 0 8px 8px;
    width: 594px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    background: #fafbfd;
    flex-grow: 0;
    flex-shrink: 0;

    .form-sel-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 8px;

        .input-opt {
            width: 539px;

            input {
                border-radius: 4px;
                padding: 9px 8px 10px 8px;
                background: #fff;
                width: 100%;
                border: solid 1px #d8e4f0;
                box-sizing: border-box;
            }
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .sel-item-add {
        justify-content: space-between;
        align-items: center;
        width: 539px;

        .sel-radio {
            & > div {
                display: inline-block;
                margin-right: 8px;
                width: 18px;
                height: 18px;
                background: url($zhijiStaticImagePath+"class-spr.png");
                background-position: -275px 0;
                vertical-align: text-bottom;
                cursor: pointer;
            }

            .on {
                background-position: -275px -20px;
            }
        }
    }
}
</style>
